// Words for the What's next contract's values (apiv2/dashboard_setup_steps.openapi.yaml), and the dashboard
// pages its `link` steps are done on. whatsNextContract.test.js checks that every enum value and refusal code
// of the contract has words here; an unknown value (a newer backend) is shown as it is.

/** The sections, in the contract's order. */
export const SETUP_GROUPS: Record<string, string> = {
    app: 'Your app',
    brand: 'Your brand',
    contacts: 'Contacts and legal pages',
    guest: 'Guest experience',
    team: 'Your team',
};

export const SETUP_STATES: Record<string, string> = {
    todo: 'To do',
    attention: 'Needs attention',
    done: 'Done',
};

/** The icon of a step's state (the lane icons of the Onboarding page). */
export const STATE_ICONS: Record<string, string> = {
    todo: 'pending',
    attention: 'attention',
    done: 'done',
};

/** The page's own words for each refusal code (`detail`, the server's words, for anything else). */
export const SETUP_ERROR_CODES: Record<string, string> = {
    permission_denied: 'Only an account admin can change the setup.',
    not_easy: 'These setup steps are not available for this account.',
    unknown_step: 'This step is not available any more. Reload the page.',
    not_applicable: 'This step does not apply to your account any more. Reload the page.',
    fields_not_allowed: 'Some of these values cannot be changed here.',
    invalid_values: 'Some values are not valid. Check the fields marked in red.',
    not_editable: 'This step is not completed with a form.',
    no_upload: 'This step takes no image.',
    not_dismissible: 'This step cannot be hidden.',
    file_required: 'Choose an image to upload.',
    image_type: 'Upload a JPG, PNG, GIF or WebP image.',
    image_too_large: 'That image is too large. Upload one under 15 MB and 50 megapixels.',
    image_too_small: 'That image is too small. Upload a larger one (see the size above).',
    image_unreadable: "We couldn't read that image. Upload another file.",
    image_orientation: 'That picture relies on a rotation setting. Rotate it in an image editor, save it and upload it again.',
    image_empty: 'That file is empty. Upload another file.',
    upload_too_large: 'That file is too large to upload. Upload one under 15 MB.',
    upload_failed: 'Your image could not be processed right now. Try again in a few minutes.',
};

/** Where a step is done in the dashboard (a `link` step), or where its details are (pre-check-in). */
export const STEP_PAGES: Record<string, { path: string; label: string }> = {
    support_contacts: { path: '/settings/general/support-contacts', label: 'Open support contacts' },
    social_links: { path: '/settings/general/support-contacts', label: 'Open support contacts' },
    review_link: { path: '/settings/general/reviews', label: 'Open review settings' },
    meeting_points: { path: '/trip', label: 'Open your trips' },
    team: { path: '/user', label: 'Open users' },
    precheckin: { path: '/settings/checkin', label: 'Open pre-check-in settings' },
};

/** What an upload step takes, in words (the backend's limits: 15 MB, 50 megapixels). */
export const UPLOAD_HINTS: Record<string, string> = {
    logo: 'A square logo on a plain background works best. JPG, PNG, GIF or WebP, up to 15 MB.',
    app_graphics: 'A square image, such as your logo on a plain background. JPG, PNG, GIF or WebP, up to 15 MB.',
    app_promo_image: 'A picture of your app or your tours. JPG, PNG, GIF or WebP, up to 15 MB.',
};
